import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, getParent } from '@fretadao/f-js-dom';

application.register(
  'drivers',
  class extends Controller {
    static targets = ['driversLicense'];
    static values = { newRecord: Boolean}

    connect() {
      if (!this.newRecordValue){
        this.driversLicenseTarget.removeAttribute('required');
      }
    }
  }
)